<form [formGroup]="form" (ngSubmit)="submit()" class="space-y-6">
  <!-- Dropdown for Selecting Recommendation Type -->
  <div class="flex flex-col space-y-2">
    <label for="type" class="font-bold">რეკომენდაციის ტიპი</label>
    <select
      id="type"
      formControlName="type"
      class="border-gray-300 border rounded-lg p-2 focus:ring focus:ring-blue-500"
      >
      <option [value]="null" disabled>Select a type</option>
      @for (type of recommendationTypes; track type) {
        <option [value]="type.type">
          {{ type.label }}
        </option>
      }
    </select>
  </div>

  @if (selectedType === 'SURGICAL' || selectedType ===  'INSTRUMENTAL' || selectedType ===  'CONSULTATION') {
    <div class="space-y-4">
      <div class="flex flex-col space-y-2">
        <label>Ncsp</label>
        <nz-tree-select
          formControlName="ncspId"
          [nzNodes]="classificationCodeService.classificationNCSPCodes()"
          nzShowSearch
          nzPlaceHolder="Please select"
          nzVirtualHeight="300px"
          nzHideUnMatched="true"
          nzCheckStrictly="true"
          nzShowLine="true"
          nzSize="large"
        ></nz-tree-select>
      </div>
    </div>
  }

  @if (selectedType === 'SURGICAL') {
    <div class="space-y-4">
      <div class="flex flex-col space-y-2">
        <label>NCSP კომენტარი</label>
        <textarea
          rows="3"
          formControlName="ncspComment"
          class="border-gray-300 border rounded-lg p-2 focus:ring focus:ring-blue-500"
        ></textarea>
      </div>
    </div>
  }

  @if (selectedType === 'SURGICAL') {
    <div class="space-y-4">
      <div class="flex flex-col space-y-2">
        <label>ICD10</label>
        <nz-tree-select
          formControlName="icd10Id"
          [nzNodes]="classificationCodeService.classificationICDCodes()"
          nzShowSearch
          nzPlaceHolder="Please select"
          nzVirtualHeight="300px"
          nzHideUnMatched="true"
          nzCheckStrictly="true"
          nzShowLine="true"
          nzSize="large"
        ></nz-tree-select>
      </div>
    </div>
  }
  @if (selectedType === 'SURGICAL') {
    <div class="space-y-4">
      <div class="flex flex-col space-y-2">
        <label>ICD10 კომენტარი</label>
        <textarea
          rows="3"
          formControlName="icd10Comment"
          class="border-gray-300 border rounded-lg p-2 focus:ring focus:ring-blue-500"
        ></textarea>
      </div>
    </div>
  }
  @if (selectedType === 'INSTRUMENTAL') {
    <div class="space-y-4">
      <div class="flex flex-col space-y-2">
        <label>კვლევის თარიღი</label>
        <beautyapp-datepicker
          formControlName="instrumentalExplorationsDate"
          size="large"
          />
      </div>
    </div>
  }

  @if (selectedType === 'CONSULTATION') {
    <div class="space-y-4">
      <beautyapp-select
        label="{{'users.column.medicalSpecialty' | translate}}"
        placeholder="{{'users.column.medicalSpecialty' | translate}}"
        [data]="medicalSpecialties"
        displayMember="value"
        valueMember="id"
        formControlName="specialtyCode"
        size="large"
        >
      </beautyapp-select>
    </div>
  }
  @if (selectedType === 'CONSULTATION') {
    <div class="space-y-4">
      <div class="flex flex-col space-y-2">
        <label>რეკომენდაციის ვადა</label>
        <beautyapp-datepicker
          formControlName="deadline"
          size="large"
          />
      </div>
    </div>
  }
  @if (selectedType === 'INSTRUMENTAL' || selectedType === 'CONSULTATION') {
    <div class="space-y-4">
      <div class="flex flex-col space-y-2">
        <label>ექიმის კომენტარი</label>
        <textarea
          rows="3"
          formControlName="doctorComment"
          class="border-gray-300 border rounded-lg p-2 focus:ring focus:ring-blue-500"
        ></textarea>
      </div>
    </div>
  }

  @if (selectedType === 'OTHER') {
    <div class="space-y-4">
      <div class="flex flex-col space-y-2">
        <label>რჩევა/დარიგება</label>
        <textarea
          rows="3"
          formControlName="recommendation"
          class="border-gray-300 border rounded-lg p-2 focus:ring focus:ring-blue-500"
        ></textarea>
      </div>
    </div>
  }

  <!-- Dynamic Form Fields -->
  <!--  <div *ngIf="selectedType" class="space-y-4">-->
  <!--    <div *ngFor="let field of fieldConfig[selectedType]" class="flex flex-col space-y-2">-->
  <!--      <label [for]="field.name">{{ field.label }}</label>-->

  <!--      @if (field.type === 'icd'){-->
  <!--        <nz-tree-select-->
  <!--          [formControlName]="field.name"-->
  <!--          [nzNodes]="visitAddFacade.classificationICDCodes()"-->
  <!--          nzShowSearch-->
  <!--          nzPlaceHolder="Please select"-->
  <!--          nzVirtualHeight="300px"-->
  <!--          nzHideUnMatched="true"-->
  <!--          nzCheckStrictly="true"-->
  <!--          nzShowLine="true"-->
  <!--          nzSize="large"-->
<!--        ></nz-tree-select>-->
<!--      }-->

<!--      @if (field.type === 'ncsp'){-->
<!--        <nz-tree-select-->
<!--          [formControlName]="field.name"-->
<!--          [nzNodes]="visitAddFacade.classificationNCSPCodes()"-->
<!--          nzShowSearch-->
<!--          nzPlaceHolder="Please select"-->
<!--          nzVirtualHeight="300px"-->
<!--          nzHideUnMatched="true"-->
<!--          nzCheckStrictly="true"-->
<!--          nzShowLine="true"-->
<!--          nzSize="large"-->
<!--        ></nz-tree-select>-->
<!--      }-->
<!--      &lt;!&ndash; Input Field &ndash;&gt;-->
<!--      <input-->
<!--        *ngIf="field.type === 'text'"-->
<!--        type="text"-->
<!--        [formControlName]="field.name"-->
<!--        class="border-gray-300 border rounded-lg p-2 focus:ring focus:ring-blue-500"-->
<!--      />-->

<!--      &lt;!&ndash; Textarea Field &ndash;&gt;-->
<!--      <textarea-->
<!--        *ngIf="field.type === 'textarea'"-->
<!--        rows="3"-->
<!--        [formControlName]="field.name"-->
<!--        class="border-gray-300 border rounded-lg p-2 focus:ring focus:ring-blue-500"-->
<!--      ></textarea>-->

<!--      @if (field.type === 'date') {-->
<!--        <beautyapp-datepicker-->
<!--          [formControlName]="field.name"-->
<!--          size="large"-->
<!--        />-->
<!--      }-->
<!--    </div>-->
</form>
<div *nzModalFooter>
  <button nz-button nzType="default" nzSize="large" (click)="modal.close()">{{ 'buttons.close' | translate }}</button>
  <button type="button" nz-button nzSize="large" nzType="primary" (click)="submit()">{{ 'buttons.save' | translate }}
  </button>
</div>
